<script>
    export let sliderLeft;
</script>

<section>
    <div style="position:relative;height:85vw;">
        <div class="job-div">
            <p class="hero-text">7000+ New Jobs</p>
        </div>
        <div class="Company-div">
            <p class="hero-text">650+ Companies</p>
        </div>
        <div class="border-div" />
        <div class="slider">
            {#each sliderLeft as data}
                <div class="sli">
                    <div class="slider-img">
                        <img src={data.image} alt="" width="100%" />
                    </div>
                    <div class="data-part">
                        <p class="name-text">{data.person_name}</p>
                        <p class="logo-text">{data.company_name}</p>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</section>

<style>
    .job-div {
        width: 37.677vw;
        height: 12.5vw;
        background: linear-gradient(285.51deg, #3382c0 0%, #66bafb 99.38%);
        border-radius: 10vw 0vw 0vw 0vw;
        border: 0.198vw solid #7cc1ff;
        position: absolute;
        left: 9.028vw;
    }
    .Company-div {
        width: 37.677vw;
        height: 12.5vw;
        background: linear-gradient(74.12deg, #00204b 1.5%, #00429b 99.49%);
        left: 46.65vw;
        border-radius: 0vw 10vw 0vw 0vw;
        border: 0.198vw solid #7cc1ff;
        border-left: none;
        position: absolute;
        top: 0vw;
    }
    .hero-text {
        font-size: 3.056vw;
        margin-top: 4.746vw;
        text-align: center;
        font-weight: 600;
        color: white;
    }
    .border-div {
        width: 84.722vw;
        height: 60vw;
        border: 0.398vw solid #7cc1ff;
        border-radius: 0vw 0vw 0vw 10vw;
        position: absolute;
        border-top: none;
        top: 12.5vw;
        left: 9vw;
        border-right: none;
    }
    .slider {
        scroll-behavior: smooth;
        display: flex;
        justify-content: space-between;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        position: absolute;
        top: 19.5vw;
        width: 85vw;
        height: 50vw;
        left: 15vw;
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .sli {
        scroll-snap-align: start;
        margin-top: 5vw;
    }
    .slider-img img {
        width: 20vw;
        height: 20vw;
    }
    .name-text {
        font-size: 3.056vw;
        font-weight: 500;
        margin-top: 8vw;
        line-height: 1.7vw;
    }
    .data-part {
        margin-top: 2.183vw;
        justify-content: space-between;
    }
    .logo-text {
        font-size: 3.056vw;
        color: #3c74c0;
        margin-right: 5vw;
        width: 35vw;
        margin-top: 5vw;
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .name-text,
    .logo-text,
    p {
        margin-bottom: 0vw;
    }
</style>
